import { useIntl } from 'react-intl';
import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { SvgIcon, Tooltip, TooltipProps } from '@rossum/ui/material';

export const restrictedAccessIconLabel = 'restricted-access-actions-icon';

export const RestrictedAccessIcon = ({
  placement = 'left',
}: Pick<TooltipProps, 'placement'>) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={intl.formatMessage({
        id: 'features.pricing.documentArchive.blurredAnnotation.text',
      })}
      placement={placement}
    >
      <SvgIcon
        className={restrictedAccessIconLabel}
        data-cy={restrictedAccessIconLabel}
        color="warning"
        fontSize="medium"
      >
        <IconAlertTriangle />
      </SvgIcon>
    </Tooltip>
  );
};
